import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface FixedTooltipProps {
  text: string
  x: number
  y: number
  className?: string
}

const MyFixedTooltip: React.FC<FixedTooltipProps> = ({
  text,
  x,
  y,
  className,
}) => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
    return () => setIsVisible(false)
  }, [])

  return (
    <div
      className={`fixed bg-black/75 transition-opacity duration-500 text-white px-2.5 py-1.5 rounded pointer-events-none z-[1000] ${
        isVisible ? 'opacity-100' : 'opacity-0'
      } ${className || ''}`}
      style={{
        top: `${y}px`,
        left: `${x}px`,
        transform: 'translate(-50%, -110%)',
      }}
    >
      {t(text)}
    </div>
  )
}

export default MyFixedTooltip
